// i18n
import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/TeamPage/i18n.json';

import { useContext, useEffect } from 'react';
import { GetServerSideProps } from 'next';
import MainDocument from 'presentations/views/components/MainDocument';
import TeamPage from 'presentations/views/components/pages/TeamPage';
import { get } from 'infras/rest_client';
import {
  apiPath,
  teamOgpImagePath,
  teamPath,
  webPath,
} from 'presentations/routes/path';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import { TeamItem } from 'presentations/api/schema/team';
import { SharedEventTypeListItem } from 'presentations/api/schema/event_type';
import { formatToSeconds } from 'infras/datetime';
import { GaTracker } from 'presentations/views/helpers/analytics/user_tracking/ga';
import { MetaPixelTracker } from 'presentations/views/helpers/analytics/user_tracking/meta_pixel';

interface ServerProps {
  team: TeamItem;
  eventTypes: SharedEventTypeListItem[];
  linkCanonical: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  params,
  locale,
}: any) => {
  const result = await get(apiPath('/v1/teams/-', { slug: params.teamId }));
  if (!result.isSuccess || !result.data) {
    return { props: { statusCode: 404 } };
  }
  const team: TeamItem = result.data;
  try {
    const results = await Promise.all([
      new Promise(async (resolve, reject) => {
        const result = await get(
          apiPath('/v1/guests/event_types', { teamId: team.uid }),
        );
        if (!result.isSuccess) {
          reject();
          return;
        }
        resolve(result.data);
      }),
    ]);
    const eventTypes = results[0] as SharedEventTypeListItem[];
    const props: ServerProps = {
      team,
      eventTypes,
      linkCanonical: webPath(teamPath(team.slug), locale),
    };
    return { props };
  } catch (error) {
    console.log(error);
    return { props: { statusCode: 404 } };
  }
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  useEffect(() => {
    GaTracker.inviteeSchedulingPage();
    MetaPixelTracker.inviteeSchedulingPage();
  }, []);

  return (
    <MainDocument
      title={t('title', { name: props.team.name })}
      description={props.team.profile || ''}
      image={teamOgpImagePath(props.team.uid)}
      linkCanonical={props.linkCanonical}
      isNoIndex
      // userGoogleAnalyticsTrackingId={props.team.googleAnalyticsId}
      // userMetaPixelTrackingId={props.team.metaPixelId}
    >
      <TeamPage
        viewer={viewer}
        team={props.team}
        eventTypes={props.eventTypes}
      />
    </MainDocument>
  );
}
